import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CashDrawerConfirmationModal } from '@max/finance/shared/components/cashdrawer-confirmation/cashdrawer-confirmation-modal.component';
import { EffectsModule } from '@ngrx/effects';
import { AccordionModule } from 'primeng/accordion';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DropdownModule } from 'primeng/dropdown';
import { TableModule } from 'primeng/table';
import { CustomerDetailsModalModule } from '../customer/detail/customer-detail-modal/customer-details-modal.module';
import { CustomerRequestModalComponent } from '../customer/request/customer-request-modal.component';
import { CustomerRequestQueueComponent } from '../customer/request/customer-request-queue.component';
import { CustomerRequestService } from '../customer/request/customer-request-queue.service';
import { CashDrawerConfirmationComponent } from '../finance/shared/components/cashdrawer-confirmation/cashdrawer-confirmation.component';
import { CartService } from '../finance/shared/services/cart.service';
import { FinanceSharedService } from '../finance/shared/services/finance-shared.service';
import { AircraftSearchBarModule } from '../shared/components/aircraft/aircraft-search-bar.module';
import { CustomerSearchBarModule } from '../shared/components/customer-searchbar/customer-search-bar.module';
import { SearchModule } from '../shared/components/search/search.module';
import { SharedComponentsModule } from '../shared/components/shared-components.module';
import { ValidationResultsModule } from '../shared/components/validation-results/validation-results.module';
import { VehicleSearchBarModule } from '../shared/components/vehicle/vehicle-search-bar.module';
import { SharedDirectivesModule } from '../shared/directives/shared-directives.module';
import { MVMSpinnerBtnModule } from '../shared/mvm-components/mvm-spinner-btn/mvm-spinner-btn.module';
import { SharedPipesModule } from '../shared/pipes/shared-pipes.module';
import { BusinessTransactionService } from '../shared/services/business-transaction/business-transaction.service';
import { AAMVAIntegrationService } from '../titleregistration/services/aamvaIntegration.service';
import { PlateService } from '../titleregistration/services/plate.service';
import { TransactionService } from '../titleregistration/services/transaction.service';
import { VehicleSearchModule } from '../vehicle/search/vehicle-search/vehicle-search.module';
import { VehiclePermitService } from '../vehicle/services/vehicle-permit.service';
import { ServiceIconsComponent } from './agent/service-icons/service-icons.component';
import { TransactionEnrollmentComponent } from './assignment/transaction-enrollment.component';
import { TransactionTransferModal } from './assignment/transaction-transfer-modal.component';
import { PersonalQueuePipe } from './pipes/personal-queue.pipe';
import { CVPTransactionTypeComponent } from './prequal/greeter/cvp-transaction-type.component';
import { IRPTransactionTypeComponent } from './prequal/greeter/irp-transaction-type.component';
import { TnRTransactionTypeComponent } from './prequal/greeter/tnr-transaction-type.component';
import { TransactionPrequalWindowComponent } from './prequal/transaction-prequal-modal.component';
import { TransactionPrequalComponent } from './prequal/transaction-prequal.component';
import { BuQueueComponent } from './queue/components/bu-queue.component';
import { EscalationQueueComponent } from './queue/components/escalation-queue.component';
import { MyAssignmentsComponent } from './queue/components/my-assignments.component';
import { MyEscalationsComponent } from './queue/components/my-escalations.component';
import { SelectAssignmentComponent } from './queue/components/select-assignment.component';
import { DifferentAgentCartWindow } from './queue/modals/different-agent-cart-modal.component';
import { OpenTransactionWindow } from './queue/modals/open-transaction-modal.component';
import { OverrideRequestWindow } from './queue/modals/override-request-modal.component';
import { ReassignActiveWindow } from './queue/modals/reassign-active-modal.component';
import { TransactionActiveWindow } from './queue/modals/transaction-active-modal.component';
import { TransactionDeleteWindow } from './queue/modals/transaction-delete-modal.component';
import { UnassignActiveWindow } from './queue/modals/unassign-active-modal.component';
import { ViewTransactionWindow } from './queue/modals/view-transaction-modal.component';
import { TransactionQueueComponent } from './queue/transaction-queue.component';
import { CheckinService } from './services/checkin.service';
import { CustomerListService } from './services/customer-list.service';
import { WipSearchService } from './services/wip-search.service';
import { TransactionEffects } from './state/transaction.effects';

@NgModule({
    declarations: [
        BuQueueComponent,
        CashDrawerConfirmationComponent,
        CustomerRequestModalComponent,
        CustomerRequestQueueComponent,
        DifferentAgentCartWindow,
        EscalationQueueComponent,
        MyAssignmentsComponent,
        MyEscalationsComponent,
        OpenTransactionWindow,
        OverrideRequestWindow,
        PersonalQueuePipe,
        ReassignActiveWindow,
        SelectAssignmentComponent,
        ServiceIconsComponent,
        TnRTransactionTypeComponent,
        CVPTransactionTypeComponent,
        IRPTransactionTypeComponent,
        TransactionActiveWindow,
        TransactionDeleteWindow,
        TransactionEnrollmentComponent,
        TransactionPrequalComponent,
        TransactionPrequalWindowComponent,
        TransactionQueueComponent,
        UnassignActiveWindow,
        ViewTransactionWindow,
        CashDrawerConfirmationModal,
        TransactionTransferModal,
    ],
    providers: [
        AAMVAIntegrationService,
        BusinessTransactionService,
        CartService,
        CheckinService,
        CustomerListService,
        CustomerRequestService,
        FinanceSharedService,
        PlateService,
        TransactionService,
        VehiclePermitService,
        WipSearchService
    ],
    imports: [
        AccordionModule,
        AutoCompleteModule,
        CommonModule,
        CustomerDetailsModalModule,
        CustomerSearchBarModule,
        DropdownModule,
        EffectsModule.forFeature([TransactionEffects]),
        FormsModule.withConfig({callSetDisabledState: 'whenDisabledForLegacyCode'}),
        MVMSpinnerBtnModule,
        ReactiveFormsModule,
        SearchModule,
        SharedComponentsModule,
        SharedDirectivesModule,
        SharedPipesModule,
        ValidationResultsModule,
        VehicleSearchBarModule,
        VehicleSearchModule,
        TableModule,
        AircraftSearchBarModule
    ],
    exports: [
        ServiceIconsComponent,
        TransactionPrequalComponent
    ]
})
export class TransactionCoreModule {
}
